(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/results/assets/javascripts/collections/results.js') >= 0) return;  svs.modules.push('/components/numbergames/results/assets/javascripts/collections/results.js');

'use strict';

svs.numbergames.results.collections.Results = svs.numbergames.core.NumbergamesCollection.extend({
  model: svs.numbergames.results.models.Result,
  comparator(a, b) {
    let sortOrder = b.get('drawNumber') - a.get('drawNumber');
    if (a.get('productId') === 'LOTTO') {
      const [regCloseA] = a.get('regCloseTime').split('T'),
        [regCloseB] = b.get('regCloseTime').split('T'),
        [ay, am, ad] = regCloseA.split('-'),
        [by, bm, bd] = regCloseB.split('-'),
        sortByYear = by - ay,
        sortByMonth = bm - am,
        sortByDate = bd - ad;
      sortOrder = sortByYear || sortByMonth || sortByDate;
    }
    return sortOrder;
  },
  fetchResultByDraw(draw) {
    let {
      context,
      success
    } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!draw) return;
    const model = this.getResultByDraw(draw);
    if (model) {
      if (typeof success === 'function') success.call(context, model);
    } else {
      this.create({
        productDrawId: draw.productDrawId,
        drawNumber: draw.drawNumber,
        addonDrawId: draw.addonDrawId,
        addonDrawNumber: draw.addonDrawNumber
      }, {
        wait: true,
        context,
        success
      });
    }
  },
  getResultByDraw() {
    let {
      productDrawId,
      drawNumber
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return this.findWhere({
      productDrawId,
      drawNumber
    });
  }
});

 })(window);